import React from 'react';
import styles from './styles.module.scss';
import { StyledTableCell, StyledTableRow } from 'components/StyledComponents';
import { TableWrapper } from 'components/SummaryComponents';
import { Table, TableBody, TableHead } from '@material-ui/core';

export default function AssetPrefixesTable({ assetPrefixes }) {
  if (!assetPrefixes?.length) return null;

  const rows = assetPrefixes.flatMap((prefix) =>
    prefix.assets.map((asset, index) => ({
      ...asset,
      prefixName: prefix.prefix,
      isFirst: index === 0,
      rowSpan: prefix.assets.length
    }))
  );

  return (
    <TableWrapper>
      <Table>
        <TableHead>
          <StyledTableRow>
            <StyledTableCell className={styles.prefixes__prefix_head_cell}>Prefix</StyledTableCell>
            <StyledTableCell className={styles.prefixes__dr_code_head_cell}>Assets</StyledTableCell>
            <StyledTableCell className={styles.prefixes__location_head_cell}>
              Point of origin (Sublocation)
            </StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.id} className={styles.prefixes__body_row}>
              {row.isFirst && (
                <StyledTableCell rowSpan={row.rowSpan} className={styles.prefixes__prefix_cell}>
                  {row.prefixName || ''}
                </StyledTableCell>
              )}
              <StyledTableCell className={styles.prefixes__dr_code_cell}>
                {row.drCode || ''}
              </StyledTableCell>
              <StyledTableCell className={styles.prefixes__location_cell}>
                {row.pointOfOrigin || ''}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableWrapper>
  );
}
